import { Component, OnInit, EventEmitter, Input, Output, ViewChild, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { RbacService } from '@stg-js-ngx-core/oauth';
import { Subscription } from 'rxjs';
import { MmtCommonService } from '../../services/mmt-common.service';
import { HierarchyTreeComponent } from '@stg-js-ngx-core/hierarchy-tree';


@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-hierarchy-selector',
  templateUrl: './hierarchy-selector.component.html',
  styleUrls: ['./hierarchy-selector.component.scss']
})
export class HierarchySelectorComponent implements OnInit, OnDestroy {
  selectedTeam: string;
  isAvailable: boolean = true;
  @Input() disabled: boolean = false;
  @Input() showHierarchyLabel: boolean = true;
  roleChangeCounter: number = 0;
  @Output() hierarchyValueSelected: EventEmitter<any> = new EventEmitter<any>();
  hierarchyChangeSubscription: Subscription;
  showHierarchyComponent: boolean = true;
  hierarchyArray: any = [];
  isReportOrExportComponent: boolean = false;
  @ViewChild(HierarchyTreeComponent, { static: false }) hierarchyComponent: HierarchyTreeComponent;

  constructor(private commonService: MmtCommonService,
    private rbacService: RbacService) { }

  ngOnInit(): void {
    if (!this.showHierarchyLabel) {
      this.isReportOrExportComponent = true;
    } else {
      this.isReportOrExportComponent = false;
    }
    this.hierarchyChangeSubscription = this.commonService.hierarchyChange
      .subscribe(res => {
        this.commonService.hierarchy = res;
        if (res && res.length > 0) {
          const hadNoSelection = !this.selectedTeam;
          this.selectedTeam = res[0];
          this.isAvailable = false;
          // <app-hierarchy> only reads its inputs in ngOnInit (no ngOnChanges),
          // so when teams arrive after this component already mounted (e.g. deep
          // link to /reports), force a re-mount so the selection renders.
          if (hadNoSelection && this.showHierarchyComponent) {
            this.showHierarchyComponent = false;
            setTimeout(() => { this.showHierarchyComponent = true; }, 0);
          }
        }
      });
    if (this.commonService.hierarchy) {
      this.selectedTeam = this.commonService.hierarchy[0];
      this.isAvailable = false;
    }
    else {
      this.isAvailable = true;
      let selectedTeamobj = this.commonService.getDefaultHierarchy();
      if (selectedTeamobj) {
        this.commonService.hierarchy = selectedTeamobj;
        this.selectedTeam = selectedTeamobj.team_name;
        this.commonService.selectedTeamDefaultValue = selectedTeamobj.team_name;
      }
    }
    this.rbacService.roleChangeObservable.subscribe((res: any) => {
      if (res && res.teams && res.teams[0]) {
        this.showHierarchyComponent = false;
        setTimeout(() => {
          this.showHierarchyComponent = true;
        }, 50);
      }
    });
  }

  hierarchySelected(event) {
    this.hierarchyArray = [];
    this.hierarchyArray.push({ team_name: event.team_name, team_description: event.team_description });
    this.selectedTeam = this.hierarchyArray;
    this.commonService.hierarchyChange.next(this.selectedTeam);
    this.hierarchyValueSelected.emit(event.team_name);
  };

  ngOnDestroy(): void {
    if (this.hierarchyChangeSubscription) {
      this.hierarchyChangeSubscription.unsubscribe();
    }
  }
}
